var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaypal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "paypal",
    xmlns: "http://www.w3.org/2000/svg",
    width: 99,
    height: 43,
    viewBox: "0 0 99 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_161407",
    "data-name": "Rectangle 161407",
    width: 99,
    height: 43,
    rx: 5,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "paypal-color",
    transform: "translate(13.299 12.289)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38302",
    "data-name": "Path 38302",
    d: "M136.283,11.106l-1.7,10.658a.272.272,0,0,0,.271.315h2.008a.3.3,0,0,0,.3-.249l1.7-10.658a.272.272,0,0,0-.271-.315h-2.008a.293.293,0,0,0-.3.249Zm-2.144,3.11h-1.9a.3.3,0,0,0-.295.249l-.063.392a3.624,3.624,0,0,0-4.1-.52,4.529,4.529,0,0,0-2.531,2.843s-.974,2.855,1.229,4.427a3.783,3.783,0,0,0,4.344-.093l-.04.25a.275.275,0,0,0,.271.315h1.906a.293.293,0,0,0,.3-.249l1.159-7.3a.267.267,0,0,0-.063-.22.272.272,0,0,0-.21-.1Zm-2.8,4.034a2.116,2.116,0,0,1-.725,1.309,2.145,2.145,0,0,1-1.414.509,1.946,1.946,0,0,1-.6-.087,1.674,1.674,0,0,1-1.157-1.9,2.118,2.118,0,0,1,.726-1.308,2.148,2.148,0,0,1,1.413-.51,1.945,1.945,0,0,1,.6.088,1.669,1.669,0,0,1,1.159,1.9h0Zm-10.171.2a4.35,4.35,0,0,0,2.817-1.034,4.29,4.29,0,0,0,1.461-2.6,3.493,3.493,0,0,0-3.683-3.954h-3.794a.3.3,0,0,0-.295.249l-1.7,10.658a.275.275,0,0,0,.271.315h2.009a.3.3,0,0,0,.295-.249l.5-3.13a.293.293,0,0,1,.3-.249l1.822,0Zm1.68-3.734c-.124.781-.732,1.355-1.9,1.355h-1.487l.452-2.838h1.46c1.2,0,1.594.706,1.47,1.485Z",
    transform: "translate(-67.783 -7.112)",
    fill: "#0070e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38303",
    "data-name": "Path 38303",
    d: "M76.217,14.4l-2.3,3.85L72.753,14.43a.293.293,0,0,0-.284-.209H70.4a.222.222,0,0,0-.223.189.218.218,0,0,0,.011.1l2.09,6.437-1.89,3.033a.218.218,0,0,0,.076.308.223.223,0,0,0,.114.03h2.233a.37.37,0,0,0,.318-.178L78.96,14.56a.216.216,0,0,0,0-.224.222.222,0,0,0-.2-.111H76.537A.371.371,0,0,0,76.217,14.4Zm-7-.181H67.314a.3.3,0,0,0-.3.249l-.062.392a3.626,3.626,0,0,0-4.1-.52,4.524,4.524,0,0,0-2.53,2.843s-.975,2.855,1.228,4.427a3.784,3.784,0,0,0,4.344-.093l-.04.25a.275.275,0,0,0,.271.315h1.906a.3.3,0,0,0,.295-.249l1.16-7.3a.271.271,0,0,0-.156-.29.277.277,0,0,0-.115-.025Zm-2.8,4.035a2.119,2.119,0,0,1-.726,1.307,2.149,2.149,0,0,1-1.413.51,1.947,1.947,0,0,1-.6-.087,1.674,1.674,0,0,1-1.156-1.9,2.119,2.119,0,0,1,.729-1.31,2.149,2.149,0,0,1,1.418-.508,1.944,1.944,0,0,1,.6.088,1.671,1.671,0,0,1,1.15,1.9h0Zm-10.171.2a4.348,4.348,0,0,0,2.814-1.035,4.289,4.289,0,0,0,1.46-2.6,3.492,3.492,0,0,0-3.682-3.953H53.044a.3.3,0,0,0-.3.249L51.057,21.769a.271.271,0,0,0,.156.29.276.276,0,0,0,.115.025h2.008a.3.3,0,0,0,.3-.249l.5-3.13a.293.293,0,0,1,.3-.249h1.822Zm1.68-3.734c-.124.781-.731,1.355-1.895,1.355H54.545L55,13.239h1.46c1.2,0,1.594.707,1.471,1.485v0Z",
    transform: "translate(-30.313 -7.117)",
    fill: "#003087"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38304",
    "data-name": "Path 38304",
    d: "M15.115,6.483c.045-2.353-1.9-4.159-4.565-4.159H5.028a.54.54,0,0,0-.534.456L2.283,16.6a.439.439,0,0,0,.433.507H5.987l-.511,3.2a.439.439,0,0,0,.433.507H8.574a.517.517,0,0,0,.341-.129.489.489,0,0,0,.134-.326l.782-4.6a.67.67,0,0,1,.182-.375.443.443,0,0,1,.312-.129h1.63a5.262,5.262,0,0,0,5.237-4.443,4.028,4.028,0,0,0-2.078-4.331Z",
    transform: "translate(-2.16 -2.187)",
    fill: "#001c64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38305",
    "data-name": "Path 38305",
    d: "M10.907,17.689l-.815,5.166L9.581,26.1a.439.439,0,0,0,.434.507h2.82a.54.54,0,0,0,.533-.456l.743-4.71a.54.54,0,0,1,.533-.456H16.3a5.306,5.306,0,0,0,5.238-4.491,4.118,4.118,0,0,0-2.215-4.331,4.424,4.424,0,0,1-.051.583,5.306,5.306,0,0,1-5.237,4.491h-2.6a.54.54,0,0,0-.533.456",
    transform: "translate(-6.372 -7.864)",
    fill: "#0070e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38306",
    "data-name": "Path 38306",
    d: "M5.72,16.991H2.439a.438.438,0,0,1-.433-.507L4.218,2.456A.54.54,0,0,1,4.751,2H10.39a4.33,4.33,0,0,1,4.565,4.3,4.929,4.929,0,0,0-2.3-.548h-4.7a.54.54,0,0,0-.534.456l-.885,5.622-.816,5.166Z",
    transform: "translate(-2 -2)",
    fill: "#003087"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaypal);
export default __webpack_public_path__ + "static/media/paypal.ece44349d850315565d8c6724b0ea7d7.svg";
export { ForwardRef as ReactComponent };